import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Group dispatching.
 *
 * Perechile vechi: `settings/easeedesk/group_dispatching` si
 * `save_group_dispatch`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface DispatchGroup {
  ID: number
  department_name: string
  /** 0 = nu s-a ales niciun tip pentru echipa asta. */
  ticket_type_id: number
}

export interface GroupDispatchingShell {
  title: string
  moduleUrl: string
  groups: DispatchGroup[]
  ticket_types: { ID: number; type_name: string }[]
}

export function groupDispatchingShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'group_dispatching'],
    queryFn: () => apiGet<GroupDispatchingShell>('/settings/easeedesk/group_dispatching'),
  })
}

export function saveGroupDispatch(group: number, ticket_type: number) {
  return apiPost<{ ok?: boolean }>('/settings/easeedesk/group_dispatching', { group, ticket_type })
}
